import {
  jb_image_teaser_item_css_default
} from "./chunk.FBRHDTHJ.js";
import {
  e as e2
} from "./chunk.3XLWIJBS.js";
import {
  reset_css_default
} from "./chunk.LJHCRQCZ.js";
import {
  Linkable,
  jbLinkClickedEventToJbTrackingEvent
} from "./chunk.534YP5ZJ.js";
import {
  customElement
} from "./chunk.QAGUCU4C.js";
import {
  attachInterestEvents
} from "./chunk.AHMM4X2O.js";
import {
  A,
  b,
  i
} from "./chunk.BPIW577J.js";
import {
  e,
  n,
  r
} from "./chunk.XW2RSTES.js";
import {
  __decorateClass
} from "./chunk.LUIRGYUH.js";

// src/components/jb-image-teaser-item/jb-image-teaser-item.ts
var JbImageTeaserItem = class extends Linkable(i) {
  constructor() {
    super(...arguments);
    this._hovering = false;
  }
  async connectedCallback() {
    super.connectedCallback();
    await this.updateComplete;
    attachInterestEvents(this._linkElement);
  }
  _hoverLinkIn() {
    this._hovering = true;
  }
  _hoverLinkOut() {
    this._hovering = false;
  }
  _tracking(e3) {
    const jbTrackingEvent = jbLinkClickedEventToJbTrackingEvent(e3, {
      component_name: "image-teaser"
    });
    if (jbTrackingEvent) {
      this.dispatchEvent(jbTrackingEvent);
    }
  }
  render() {
    return b`
      <a
        @jb-link:clicked=${this._tracking}
        @interest=${this._hoverLinkIn}
        @loseinterest=${this._hoverLinkOut}
        data-linkable
      >
        <div class="col aspect_3by2">
          <div class="inner ${e2({ hovering: this._hovering })} ">
            <div class="bg">
              ${b`<jb-picture
                .alt=${this.bgImage?.alt}
                .imgData=${this.bgImage?.imgData}
                ?lazy=${this.bgImage?.lazy}
                fit="cover"
              ></jb-picture>`}
            </div>
          </div>
        </div>
        <div class="content">
          <jb-heading variant="heading-md">${this.headline}</jb-heading>
          <div class="content_wrapper">
            ${this.description ? b`<p class="description">${this.description}</p>` : A}
            ${this.languageBadge ? b`<p class="language-badge">${this.languageBadge}</p>` : A}
          </div>
          ${this.button ? b`<jb-button-tertiary
                  .forceHover=${this._hovering}
                  .text=${this.button.text}
                  tabindex="-1"
                ></jb-button-tertiary>` : A}
        </div>
      </a>
    `;
  }
};
JbImageTeaserItem.styles = [reset_css_default, jb_image_teaser_item_css_default];
__decorateClass([
  n({ type: Object })
], JbImageTeaserItem.prototype, "bgImage", 2);
__decorateClass([
  n({ type: Object })
], JbImageTeaserItem.prototype, "button", 2);
__decorateClass([
  n()
], JbImageTeaserItem.prototype, "description", 2);
__decorateClass([
  n({ reflect: true })
], JbImageTeaserItem.prototype, "headline", 2);
__decorateClass([
  n()
], JbImageTeaserItem.prototype, "languageBadge", 2);
__decorateClass([
  n({ type: Boolean })
], JbImageTeaserItem.prototype, "randomized", 2);
__decorateClass([
  r()
], JbImageTeaserItem.prototype, "_hovering", 2);
__decorateClass([
  e("a")
], JbImageTeaserItem.prototype, "_linkElement", 2);
JbImageTeaserItem = __decorateClass([
  customElement("jb-image-teaser-item")
], JbImageTeaserItem);

export {
  JbImageTeaserItem
};
